import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import React, { PureComponent } from 'react';

import GGLayoutContainer from '../../container';

import { Title } from './styles';

export default class CheckoutTitle extends PureComponent {
    render() {
        const { noMargin, hideMobile, center, tk } = this.props;
        return (
            <GGLayoutContainer>
                <Title {...this.props} noMargin={noMargin} hideMobile={hideMobile} center={center}>
                    <Translator tk={tk} />
                </Title>
            </GGLayoutContainer>
        );
    }
}
